import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { authwsEnvironment } from './authws-environment';
import { AuthUser } from './schemas/auth-user.schema';

export function postPasswordResetBulk(
  users: Partial<AuthUser>[],
  password: string,
  alias: string,
  forcePasswordReset?: boolean
) {
  const body: Record<string, unknown> = {
    users,
    password,
    alias,
  };

  if (forcePasswordReset) {
    body.forcePasswordReset = forcePasswordReset;
  }

  return fromFetch(
    new Request(authwsEnvironment.passwordResetBulkUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(body),
    })
  ).pipe(ignoreData());
}
